import { CustomerListRowFieldsFragment } from '@/types';
import { useMemo } from 'react';

export interface PricingCustomerListRow {
  grossProfitInMicros: number;
  lastInvoiceDate: string | null;
  lineItems: number;
  marginPercentage: number | null;
  orderCount: number;
  restaurantAccountId: string;
  restaurantName: string;
  restaurantUUID: string;
  revenueInMicros: number;
  salesRepName: string | null;
  salesRepUUID: string | null;
  supplierUUID: string;
}

const transformRow = (
  row: CustomerListRowFieldsFragment,
): PricingCustomerListRow | null => {
  if (!row.restaurant_id || !row.restaurant_name) {
    return null;
  }

  return {
    grossProfitInMicros: row.gross_profit_in_micros_total,
    lastInvoiceDate: row.last_invoice_date ?? null,
    lineItems: row.line_items_total,
    marginPercentage: row.margin_percentage ?? null,
    orderCount: row.order_count,
    restaurantAccountId: row.restaurant_account_id ?? '',
    restaurantName: row.restaurant_name,
    restaurantUUID: row.restaurant_id,
    revenueInMicros: row.revenue_in_micros_total,
    salesRepName: row.sales_rep_name ?? null,
    salesRepUUID: row.sales_rep_id ?? null,
    supplierUUID: row.supplier_id,
  };
};

export const useCustomerListRowTransformer = (
  data: CustomerListRowFieldsFragment[],
): PricingCustomerListRow[] => {
  return useMemo(
    () =>
      data
        .map(transformRow)
        .filter((row): row is PricingCustomerListRow => row !== null),
    [data],
  );
};
